import { useEffect } from "react";
const SERVICE_WORKER_URL = "/sw.js";
const SERVICE_WORKER_SCOPE = "/";
const SERVICE_WORKER_API = "serviceWorker";
const VISIBILITY_CHANGE_EVENT = "visibilitychange";
const VISIBLE_STATE = "visible";

/**
 * Registers the service worker that makes the site installable and available
 * offline.
 */
export const useServiceWorker = () => {
  useEffect(() => {
    if (!(SERVICE_WORKER_API in navigator)) return;
    let registration: ServiceWorkerRegistration | undefined;
    const register = async () => {
      try {
        registration = await navigator.serviceWorker.register(SERVICE_WORKER_URL, {
          scope: SERVICE_WORKER_SCOPE
        });
      } catch {
        // A failed registration must never break the page.
      }
    };
    const checkForUpdate = async () => {
      if (document.visibilityState !== VISIBLE_STATE) return;
      try {
        await registration?.update();
      } catch {
        // Update checks fail while offline; the rejection is expected.
      }
    };
    void register();
    document.addEventListener(VISIBILITY_CHANGE_EVENT, checkForUpdate);
    return () => {
      document.removeEventListener(VISIBILITY_CHANGE_EVENT, checkForUpdate);
    };
  }, []);
};